import { render } from "./LogisticMap.vue?vue&type=template&id=9f8e5cc2&scoped=true"
import script from "./LogisticMap.vue?vue&type=script&lang=js"
export * from "./LogisticMap.vue?vue&type=script&lang=js"

import "./LogisticMap.vue?vue&type=style&index=0&id=9f8e5cc2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9f8e5cc2"]])

export default __exports__